/**
 * LAPS Shopify Theme — theme.js
 * Handles: nav scroll, mobile menu, cart drawer, quantity controls,
 * add-to-cart AJAX, scroll reveal, toast notifications
 */

(function() {
  'use strict';

  /* ── Nav Scroll ──────────────────────────────────────────── */
  const nav = document.querySelector('.nav');
  if (nav) {
    const threshold = 70;
    function handleScroll() {
      if (window.scrollY > threshold) {
        nav.classList.add('scrolled');
      } else {
        nav.classList.remove('scrolled');
      }
    }
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
  }

  /* ── Mobile Menu ─────────────────────────────────────────── */
  const hamburger = document.querySelector('.hamburger');
  const mobileMenu = document.querySelector('.nav-mobile');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function() {
      const isOpen = mobileMenu.classList.toggle('is-open');
      hamburger.classList.toggle('is-open', isOpen);
      hamburger.setAttribute('aria-expanded', isOpen);
    });

    // Close on link click
    mobileMenu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        mobileMenu.classList.remove('is-open');
        hamburger.classList.remove('is-open');
        hamburger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ── Cart Drawer ─────────────────────────────────────────── */
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-overlay');
  const cartOpenBtns = document.querySelectorAll('[data-cart-open]');
  const cartCloseBtns = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (cartDrawer) {
      cartDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    if (cartOverlay) {
      cartOverlay.classList.add('is-open');
    }
  }

  function closeCart() {
    if (cartDrawer) {
      cartDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    if (cartOverlay) {
      cartOverlay.classList.remove('is-open');
    }
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      openCart();
    } else if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      closeCart();
    }
  });

  if (cartOverlay) {
    cartOverlay.addEventListener('click', closeCart);
  }

  /* ── Add to Cart (AJAX) ──────────────────────────────────── */
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (!form.matches('[data-add-to-cart-form]')) return;
    e.preventDefault();

    const submitBtn = form.querySelector('[type="submit"]');
    const originalText = submitBtn ? submitBtn.innerHTML : '';

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<span class="page-loader__spinner" style="width:20px;height:20px;border-width:2px;margin:0"></span>';
    }

    const formData = new FormData(form);
    
    // Extract any line item properties
    const properties = {};
    for (const [key, value] of formData.entries()) {
      if (key.startsWith('properties[') && value !== '') {
        const propName = key.replace('properties[', '').replace(']', '');
        properties[propName] = value;
      }
    }

    const data = {
      items: [{
        id: parseInt(formData.get('id')),
        quantity: parseInt(formData.get('quantity') || 1),
        ...(Object.keys(properties).length > 0 && { properties })
      }]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    .then(function(response) { return response.json(); })
    .then(function(data) {
      showToast('Added to bag');
      updateCartDrawer();
    })
    .catch(function(err) {
      showToast('Could not add to bag');
      console.error('Add to cart error:', err);
    })
    .finally(function() {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
      }
    });
  });

  /* ── Quick Add to Cart ───────────────────────────────────── */
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.getAttribute('data-quick-add');
    if (!variantId) return;

    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      showToast('Added to bag');
      updateCartDrawer();
    })
    .catch(function() {
      showToast('Could not add to bag');
    })
    .finally(function() {
      btn.disabled = false;
    });
  });

  /* ── Quantity Controls ───────────────────────────────────── */
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;

    const key = btn.getAttribute('data-line-key');
    const direction = btn.getAttribute('data-qty-change');
    const qtySpan = btn.parentElement.querySelector('[data-qty-value]');
    let qty = parseInt(qtySpan ? qtySpan.textContent : 1);

    if (direction === 'minus') {
      qty = Math.max(0, qty - 1);
    } else {
      qty = qty + 1;
    }

    updateCartItem(key, qty);
  });

  /* ── Remove Cart Item ────────────────────────────────────── */
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-remove-item]');
    if (!btn) return;

    const key = btn.getAttribute('data-remove-item');
    updateCartItem(key, 0);
  });

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      updateCartDrawer();
    });
  }

  /* — Update Cart Drawer (re-fetch) ————————————————— */
window.updateCartDrawer = function() {

  fetch('/cart.js?t=' + Date.now())
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function(el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });

      var drawer = document.querySelector('.cart-drawer');
      if (!drawer) { openCart(); return; }

      var itemsHtml = '';
      if (cart.item_count === 0) {
        itemsHtml = '<div class="cart-empty"><div class="cart-empty__icon"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg></div><p>Your cart is empty</p><a href="/collections/all" class="btn-primary" data-cart-close>Shop Now</a></div>';
      } else {
        var itemsInner = cart.items.map(function(item) {
          return '<div class="cart-item" data-item-key="' + item.key + '">' +
            '<div class="cart-item__image">' +
            (item.image ? '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy" width="70" height="70">' : '<div class="cart-item__placeholder"></div>') +
            '</div>' +
            '<div class="cart-item__info">' +
            '<p class="cart-item__name">' + item.product_title + '</p>' +
            (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-item__meta">' + item.variant_title + '</div>' : '') +
            '<div class="cart-item__bottom">' +
            '<div class="qty-control">' +
            '<button data-qty-change="minus" data-line-key="' + item.key + '"' + (item.quantity <= 1 ? ' disabled' : '') + ' aria-label="Decrease quantity">&minus;</button>' +
            '<span data-qty-value>' + item.quantity + '</span>' +
            '<button data-qty-change="plus" data-line-key="' + item.key + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<span class="cart-item__price">EGP ' + (item.final_line_price / 100).toFixed(2) + '</span>' +
            '</div></div>' +
            '<button class="cart-item__remove" data-remove-item="' + item.key + '" aria-label="Remove">✕</button>' +
            '</div>';
        }).join('');

        itemsHtml = '<div class="cart-items">' + itemsInner + '</div>' +
          '<div class="cart-footer">' +
          '<div class="cart-subtotal"><span>Subtotal</span><span class="cart-subtotal__amount font-bebas">EGP ' + (cart.total_price / 100).toFixed(2) + '</span></div>' +
          '<p class="cart-note">Shipping calculated at checkout</p>' +
          '<form action="/cart" method="post" novalidate><button type="submit" name="checkout" class="cart-checkout-btn" style="width:100%;border:none;cursor:pointer;">Proceed to Checkout</button></form>' +
          '<button class="cart-continue-btn" data-cart-close>Continue Shopping</button>' +
          '</div>';
      }

      var header = drawer.querySelector('.cart-drawer__header');
      drawer.innerHTML = '';
      if (header) drawer.appendChild(header);
      drawer.insertAdjacentHTML('beforeend', itemsHtml);
      openCart();
    });
}


  /* ── Toast Notifications ─────────────────────────────────── */
  function showToast(message) {
    var existing = document.querySelector('.toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'toast';
    toast.textContent = message;
    toast.style.cssText = 'position:fixed;bottom:2rem;left:50%;transform:translateX(-50%) translateY(100px);background:var(--color-red);color:var(--color-white);padding:14px 28px;border-radius:var(--radius-sm);font-family:var(--ff-heading);font-size:14px;letter-spacing:1px;z-index:9999;opacity:0;transition:transform 0.4s cubic-bezier(0.22,1,0.36,1),opacity 0.4s;pointer-events:none;';

    document.body.appendChild(toast);

    requestAnimationFrame(function() {
      toast.style.transform = 'translateX(-50%) translateY(0)';
      toast.style.opacity = '1';
    });

    setTimeout(function() {
      toast.style.transform = 'translateX(-50%) translateY(100px)';
      toast.style.opacity = '0';
      setTimeout(function() { toast.remove(); }, 500);
    }, 3000);
  }

  /* ── Scroll Reveal ───────────────────────────────────────── */
  function initScrollReveal() {
    var elements = document.querySelectorAll('.reveal-up');
    if (!elements.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    elements.forEach(function(el) {
      observer.observe(el);
    });
  }

  initScrollReveal();

  // Re-init on Shopify section load
  document.addEventListener('shopify:section:load', function() {
    initScrollReveal();
  });

  /* ── Product Page: Variant Selection ─────────────────────── */
  document.addEventListener('change', function(e) {
    if (e.target.matches('[data-variant-select]')) {
      var form = e.target.closest('form');
      if (!form) return;

      var selects = form.querySelectorAll('[data-variant-select]');
      var options = [];
      selects.forEach(function(s) { options.push(s.value); });

      // Find matching variant
      var variantsJson = form.querySelector('[data-variants-json]');
      if (variantsJson) {
        try {
          var variants = JSON.parse(variantsJson.textContent);
          var match = variants.find(function(v) {
            return v.options.every(function(opt, i) {
              return opt === options[i];
            });
          });

          if (match) {
            // Update hidden ID input
            var idInput = form.querySelector('[name="id"]');
            if (idInput) idInput.value = match.id;

            // Update price display
            var priceEl = document.querySelector('[data-product-price]');
            if (priceEl) {
              priceEl.textContent = (match.price / 100).toLocaleString('en-EG');
            }

            // Update add to cart button
            var addBtn = form.querySelector('[type="submit"]');
            if (addBtn) {
              if (match.available) {
                addBtn.disabled = false;
                addBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg> ADD TO BAG';
              } else {
                addBtn.disabled = true;
                addBtn.innerHTML = 'SOLD OUT';
              }
            }
          }
        } catch(err) {}
      }
    }
  });

  /* ── Product Gallery: Thumbnail Click ────────────────────── */
  document.addEventListener('click', function(e) {
    var thumb = e.target.closest('[data-thumb-src]');
    if (!thumb) return;

    var src = thumb.getAttribute('data-thumb-src');
    var mainImg = document.querySelector('[data-main-image]');
    if (mainImg && src) {
      mainImg.src = src;
    }

    // Update active state
    thumb.closest('.pdp-gallery__thumbs').querySelectorAll('[data-thumb-src]').forEach(function(t) {
      t.classList.remove('active');
    });
    thumb.classList.add('active');
  });

  /* ── Color Swatch Click ──────────────────────────────────── */
  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('[data-color-swatch]');
    if (!swatch) return;

    var value = swatch.getAttribute('data-color-swatch');
    var group = swatch.closest('.color-swatches');
    if (group) {
      group.querySelectorAll('[data-color-swatch]').forEach(function(s) {
        s.classList.remove('active');
      });
      swatch.classList.add('active');
    }

    // Update select element
    var select = document.querySelector('[data-variant-select][data-option-name="Color"]');
    if (select) {
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* ── Size Button Click ───────────────────────────────────── */
  document.addEventListener('click', function(e) {
    var sizeBtn = e.target.closest('[data-size-btn]');
    if (!sizeBtn) return;

    var value = sizeBtn.getAttribute('data-size-btn');
    var group = sizeBtn.closest('.size-buttons');
    if (group) {
      group.querySelectorAll('[data-size-btn]').forEach(function(s) {
        s.classList.remove('active');
      });
      sizeBtn.classList.add('active');
    }

    var select = document.querySelector('[data-variant-select][data-option-name="Size"]');
    if (select) {
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* ── User Dropdown ───────────────────────────────────────── */
  var userBtn = document.querySelector('#nav-user-btn');
  var userDropdown = document.querySelector('#user-dropdown');

  if (userBtn && userDropdown) {
    userBtn.addEventListener('click', function() {
      userDropdown.classList.toggle('is-open');
    });

    document.addEventListener('click', function(e) {
      if (!userBtn.contains(e.target) && !userDropdown.contains(e.target)) {
        userDropdown.classList.remove('is-open');
      }
    });
  }

  /* ── Collection Page: Sort ───────────────────────────────── */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

})();
